import { STORE } from "../../actions/type";

export default function stores(state = [], action) {
    switch (action.type) {
        case STORE:
            return action.payload;;
        default:
            return state
    }
}